<div class="container-fluid h-100">
  <div class="row align-items-center justify-content-center h-100">
    <div class="col-6">
      <div class="logo-wrapper">
        <img src="./../../../assets/images/logo-full-saffron.svg" alt="Bulgari logo">
      </div>
      <app-placeholder [message]="'An error occurred'|translate">
        <a class="btn btn-link p-0" routerLink="/">{{'Go back to Home'|translate}}</a>
        {{"or"|translate}}
        <button class="btn btn-primary" (click)="authService.logout()">
          {{"LOGOUT"|translate}}
        </button>
      </app-placeholder>
    </div>
  </div>
</div>
